import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { CpBody02Primary } from 'components/atoms/customer-portal/typography';
import { BgWrapper } from '../common';
import { CpChatSidePane } from './chat-list';
import { BackWrapper } from './components';
import { CpConversationPane } from './cp-conversation-pane';
import { CpChatProps } from './types';

const Holygrail = styled.div`
  display: flex;
  align-items: start;
  justify-content: space-between;
  height: 100%;
  width: 100%;
  overflow: hidden;
`;

export const CpChatForLaptop: React.FC<CpChatProps> = ({
  activeContext,
  setActiveContext,
  data,
  onProjectConversationClick,
  setCreateNewConversationInProject,
  onEntityConversationClick,
  onFilterChange,
  widget,
}) => {
  return (
    <>
      <BackWrapper>
        <CpBody02Primary className="rl-cp-widget-title" autoAdjustColor>
          <FormattedMessage id="projects.tabs.chat" />
        </CpBody02Primary>
      </BackWrapper>
      <BgWrapper
        paddingY={
          widget?.widgetDefinition?.styles?.paddingY as number | undefined
        }
      >
        <Holygrail>
          <CpChatSidePane
            activeConversation={activeContext}
            data={data}
            onAddConversationClick={(projectId: number) => {
              setCreateNewConversationInProject({
                name: '',
                projectId,
              });
            }}
            onProjectConverationClick={onProjectConversationClick}
            onEntityConversationClick={onEntityConversationClick}
          />
          <CpConversationPane
            setCreateNewConversationInProject={
              setCreateNewConversationInProject
            }
            activeContext={activeContext}
            setActiveContext={setActiveContext}
            data={data}
            onFilterChange={onFilterChange}
          />
        </Holygrail>
      </BgWrapper>
    </>
  );
};
